import sliceCreator from '../../index.jsx';
import {UPDATE_CROP} from '../../../constants/index.jsx';
const _updateCropAction = sliceCreator('UPDATE_CROP', UPDATE_CROP, 'put');

const { asyncAction: updateCropAction, reducer, clearData: clearUpdateCropAction } = _updateCropAction;

export default reducer;

export {
    updateCropAction,
    clearUpdateCropAction
}